<template>
  <div data-layout-name="newsroom">
    <div class="wrapper">
      <h1>{{ $t('Newsroom') }}</h1>

      <TabList v-slot="{ tab, active }" :tabs="TABS" :active-tab-index>
        <NuxtLink :to="tab.path" :class="active">
          {{ $t(tab.i18nKey) }}
        </NuxtLink>
      </TabList>

      <NuxtPage />
    </div>
  </div>
</template>

<script setup lang="ts">
// components
import TabList from '~/components/redesign/TabList.vue';

// composable
import useLocalePathWithSlash from '~/composables/useLocalePathWithSlash';

// constants
import { PATHS } from '~/constants/nav-items';

const route = useRoute();
const localePathWithSlash = useLocalePathWithSlash();

const TABS = [
  PATHS.IN_THE_NEWS,
  PATHS.PRESS_RELEASES,
  PATHS.PRODUCT_REVIEWS,
].map(({ path, i18nKey }) => ({ i18nKey, path: localePathWithSlash(path) }));

const activeTabIndex = computed(() =>
  TABS.findIndex(tab => tab.path === route.path),
);
</script>

<style scoped lang="scss">
@use '_/mixins/flex';
@use '_/mixins/size';
@use '_/mixins/media';
@use '_/mixins/typo';
@use '_/fn';
@use '_/variables/font';

[data-layout-name='newsroom'] {
  .wrapper {
    @include size.wrapper(80rem);

    padding: 6rem 2rem;

    @include media.tablet {
      padding: 3rem 2rem;
    }

    @include media.mobile {
      padding: 1.5rem 1rem;
    }

    h1 {
      @include typo.h2;

      margin-bottom: 3rem;

      @include media.tablet {
        margin-bottom: 2.5rem;
      }

      @include media.mobile {
        margin-bottom: 2rem;
      }
    }

    [data-component-name='TabList'] {
      margin-bottom: 2rem;

      a {
        @include flex.center-center;

        height: 100%;

        @include typo.subtitle-3;

        color: fn.token('text-primary');
        padding: 1rem 0.25rem;
        text-align: center;
        word-break: break-word;
        transition: background-color 0.15s ease;

        &:hover {
          background-color: rgb(fn.token('accent-hover'), 16%);
        }

        &:active {
          background-color: rgb(fn.token('accent-hover'), 32%);
        }

        &.active {
          color: fn.token('text-action');
        }
      }
    }
  }
}
</style>
